import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ActionsContainer,
  BookmarkWrapper,
  CloseButton,
  Divider,
  GalleryDescription,
  GalleryHeaderContainer,
  GalleryInfo
} from './styled';
import CloseIcon from '../../../../public/static/images/close-modal.svg';
import Icon from '../../../Icon';
import { Bookmark } from '../../../Bookmark';
import useScreenSize from '../../../../hooks/useScreenSize';
import { KapitalbankButton } from '../../Sections/KapitalbankButton';
import { kapitalBankButtonStyles } from '../GalleryFooter/styled';
import { BottomPhoneButton } from '../../BottomPhoneButton';
import { PhoneButtonClickHandler } from '../../BottomPhoneButton/types';
import { Tooltip } from '../../../ui/Tooltip';
import { tooltipStyles } from '../../Sections/CurrentItemTitle/styled';

interface GalleryHeaderProps {
  pageNumber: number;
  photosLength: number;
  itemId: string;
  description: ReactNode;
  price: string;
  isFavorited: boolean;
  isKapitalbankApplicable: boolean;
  isAuthor: boolean;
  phones: string[] | null;
  isShowBookmark: boolean;
  isShowPhones: boolean;
  onCreditCalcClick: () => void;
  onClose: () => void;
  setFavorited: React.Dispatch<React.SetStateAction<boolean>>;
  setClickOnGallery: PhoneButtonClickHandler;
  shouldHideSliderInfo: boolean;
}

export const GalleryHeader: React.FC<GalleryHeaderProps> = ({
  pageNumber,
  photosLength,
  itemId,
  isFavorited,
  description,
  price,
  isKapitalbankApplicable,
  isAuthor,
  phones,
  isShowBookmark,
  isShowPhones,
  onCreditCalcClick,
  onClose,
  setFavorited,
  setClickOnGallery,
  shouldHideSliderInfo
}) => {
  const { isLarge } = useScreenSize();
  const { t } = useTranslation();

  const closeButton = (
    <CloseButton
      role="button"
      tabIndex={-1}
      onClick={onClose}
      onKeyPress={onClose}
      data-cy="gallery-close-button"
    >
      <Icon IconComponent={CloseIcon} height={15} width={15} indent={false} />
    </CloseButton>
  );

  const bookmark = isShowBookmark ? (
    <BookmarkWrapper $isFavorited={isFavorited}>
      <Bookmark
        itemId={itemId}
        isActive={isFavorited}
        setFavorited={setFavorited}
        renderCurrentIcons
        isGalleryHeader
      />
    </BookmarkWrapper>
  ) : null;

  return (
    <GalleryHeaderContainer>
      {isLarge && (
        <>
          <GalleryDescription>
            <GalleryInfo tag="h2">{description}</GalleryInfo>
            <Divider />
            <GalleryInfo tag="h2">{price}</GalleryInfo>
          </GalleryDescription>

          <ActionsContainer>
            {isKapitalbankApplicable && !isAuthor && (
              <KapitalbankButton
                onClick={onCreditCalcClick}
                styles={kapitalBankButtonStyles}
              />
            )}
            {isShowPhones && !isAuthor && (
              <BottomPhoneButton
                stat="product-call-btn"
                isGallery
                isIconButton
                clickHandler={setClickOnGallery}
                isAuthor={isAuthor}
                phones={phones}
              />
            )}
            {isShowBookmark && (
              <Tooltip
                text={t('pages.bookmarks.title')}
                styles={tooltipStyles}
                tooltipTopSpace={60}
              >
                {bookmark}
              </Tooltip>
            )}
            {closeButton}
          </ActionsContainer>
        </>
      )}

      {!isLarge && (
        <>
          {closeButton}
          {!shouldHideSliderInfo && (
            <GalleryInfo tag="h3">
              {pageNumber}/{photosLength}
            </GalleryInfo>
          )}
          {bookmark}
        </>
      )}
    </GalleryHeaderContainer>
  );
};
